module.exports = __webpack_public_path__ + "static/media/video.963cece1.svg";